const video = document.getElementById("sticky-video");

document.querySelectorAll("[data-close]").forEach(function(item) {
  item.addEventListener("click", close);
});

function close(e) {
  e.target.parentElement.remove();
  document.cookie = "sticky-video-display = false";
}

let cookie = {};
document.cookie.split(";").forEach(function(el) {
  let [key, value] = el.split("=");
  cookie[key.trim()] = value;
});

if (video && (cookie["sticky-video-display"] ? false : true)) {
  video.style.display = "";
}
